import { useEffect, useState } from 'react';
import { Badge, Button, IconButton, List, Panel, Stack } from 'rsuite';
import { MultipleLevelDrawer } from './MultipleLevelDrawer';
import NoticeIcon from '@rsuite/icons/Notice';
import MoreIcon from '@rsuite/icons/More';
import { getLocalDismissNotice, updateLocalDismissNotice } from '../services';
import { t } from 'i18next';
import { useLocation, useNavigate } from 'react-router-dom';
interface IProps {
  notices: Record<string, any>;
  retentions?: Record<string, any>;
}

export const NoticeSpeaker = ({ notices, retentions }: IProps) => {
  const { pathname, state } = useLocation();
  const debug_key = state?.debug_key;
  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [openDetail, setOpenDetail] = useState<boolean>(false);
  const [emberChildren, setEmberChildren] = useState<any>('');
  const [displayNotices, setDisplayNotices] = useState<Record<string, any>>({});
  const [newNoticesNumber, setNewNoticesNumber] = useState<number>(0);

  const RetentionDetail: Record<string, any> = {
    account_id: 'Account ID',
    account_email: 'Account email',
    instance_id: 'Instance ID',
    region_alias: 'Region'
  };

  const updateEmber = (item: Record<string, any>) => {
    const { uuid, title, content, detail, region, isDismissed, type } = item;
    const dom = (
      <Panel
        header={
          <Stack spacing={10}>
            <NoticeIcon
              color={`var(--rs-primary-600)`}
              style={{ fontSize: '1.6em' }}
            />
            <b style={{ fontSize: '1.1em' }}>{title}</b>
          </Stack>
        }
      >
        <p style={{ margin: '20px 0' }}>
          {t('common.notification.serviceRegion')}: {region}
        </p>
        <p>{content}</p>
        <div style={{ marginTop: '20px' }}>
          {typeof detail === 'object' && type === 'retention' ? (
            <>
              {Object.keys(detail)
                .filter((key: string) =>
                  Object.keys(RetentionDetail).includes(key)
                )
                .map((key: string, index: number) => (
                  <Stack key={index} spacing={20}>
                    <Stack.Item style={{ fontWeight: 'bold' }}>
                      {RetentionDetail[key]}
                    </Stack.Item>
                    <Stack.Item>{detail[key]}</Stack.Item>
                  </Stack>
                ))}
              <Button
                style={{ marginTop: '20px' }}
                appearance="primary"
                onClick={() => {
                  if (detail?.account_email && detail?.id) {
                    const dataString = `${detail?.id}+${detail?.account_email}`;
                    try {
                      const res = btoa(dataString);
                      if (res) {
                        navigate(`/vm-retention?user=${res}`, {
                          state: {
                            debug_key
                          }
                        });
                      }
                    } catch (error) {
                      console.warn('encode user retention url failed', error);
                    }
                  }
                }}
              >
                Submit Retention
              </Button>
            </>
          ) : (
            <></>
          )}
        </div>
      </Panel>
    );
    uuid && !isDismissed && updateLocalDismissNotice(uuid);
    setEmberChildren(dom);
    setOpenDetail(true);
    updateDisplayNotice();
  };

  const updateDisplayNotice = () => {
    if (Object.keys(notices).length) {
      const dismissNotices: Array<string | number> = getLocalDismissNotice();
      let newItemNum: number = 0;
      const regionNames = Array.from(
        new Set([...Object.keys(notices), ...Object.keys(retentions || {})])
      );
      const data = regionNames.reduce(
        (acc: Record<string, Record<string, any>[]>, key: string) => {
          const noticeArr = notices[key] || [];
          const retentionArr = retentions?.[key] || [];
          const resArr = [...noticeArr, ...retentionArr];
          return resArr.length
            ? {
                ...acc,
                [key]: resArr.map((obj: Record<string, any>) => {
                  if (!obj.uuid || !dismissNotices.includes(obj.uuid)) {
                    newItemNum++;
                  }
                  return {
                    ...obj,
                    isDismissed:
                      obj.uuid && dismissNotices.includes(obj.uuid)
                        ? true
                        : false
                  };
                })
              }
            : acc;
        },
        {}
      );
      setDisplayNotices(data);
      setNewNoticesNumber(newItemNum);
    }
  };

  useEffect(() => {
    updateDisplayNotice();
  }, [notices, retentions]);

  const noticeIcon = () => (
    <i
      className="icon-fortinetone-notificationIcon"
      style={{ fontSize: '1.4rem' }}
    ></i>
  );
  return (
    <>
      <IconButton
        style={{
          backgroundColor: 'var(--fsr-header-bg)',
          color: 'var(--secondary-color)'
        }}
        onClick={() => {
          setOpenDrawer(true);
        }}
        icon={
          newNoticesNumber ? (
            <Badge content={newNoticesNumber}>{noticeIcon()}</Badge>
          ) : (
            noticeIcon()
          )
        }
      />
      <MultipleLevelDrawer
        open={openDrawer}
        setOpen={setOpenDrawer}
        openEmber={openDetail}
        title={`${t('common.notification.title')}`}
        setOpenEmber={setOpenDetail}
        emberChildren={emberChildren}
      >
        <>
          {Object.keys(displayNotices).length ? (
            Object.keys(displayNotices).map((name, index) => {
              const data = displayNotices[name];
              return (
                <Panel header={displayNotices[name]?.[0]?.region} key={name}>
                  <List>
                    {data.map((item: Record<string, any>, i: number) => (
                      <List.Item
                        key={i}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          updateEmber(item);
                        }}
                      >
                        <Stack spacing={20}>
                          <NoticeIcon
                            color={`var(--rs-primary-600)`}
                            style={{ fontSize: '1.2em' }}
                          />
                          <>
                            <Stack
                              spacing={2}
                              direction="column"
                              alignItems="flex-start"
                              style={{ marginBottom: '10px' }}
                            >
                              <p
                                style={{
                                  fontSize: '1.1em',
                                  fontWeight: item.isDismissed
                                    ? 'normal'
                                    : 'bold'
                                }}
                              >
                                {item.title}
                              </p>
                            </Stack>
                            <p>
                              {item.content}
                              <MoreIcon
                                style={{
                                  display: item.detail ? 'inline-block' : 'none'
                                }}
                              />
                            </p>
                          </>
                          <Badge
                            style={{
                              width: '6px',
                              height: '6px',
                              display: item.isDismissed
                                ? 'none'
                                : 'inline-block'
                            }}
                          />
                        </Stack>
                      </List.Item>
                    ))}
                  </List>
                </Panel>
              );
            })
          ) : (
            <div style={{ textAlign: 'center', marginTop: '28px' }}>
              {t('common.notification.noNotification')}
            </div>
          )}
        </>
      </MultipleLevelDrawer>
    </>
  );
};
